import { render, staticRenderFns } from "./PublicAsambleaDetail.vue?vue&type=template&id=cde10b76&scoped=true"
import script from "./PublicAsambleaDetail.vue?vue&type=script&lang=js"
export * from "./PublicAsambleaDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicAsambleaDetail.vue?vue&type=style&index=0&id=cde10b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde10b76",
  null
  
)

export default component.exports